import {getBookIdWithPrefix} from "../../utils/content/content";
import {BOOK_PERMISSION, CONTENT_CLASSES} from "../../utils/content/content.constants";

export const normalizeSearchBasicResponse = (query, response) => {
  const { total, language_facets: languageFacets = {}, suggested_query } = response.data;
  const results = response.data.results.map((item) => {
    return {
      query,
      ...item,
      isForSale: item.action_required === BOOK_PERMISSION.purchased,
      id: getBookIdWithPrefix(item.para_id),
      className: CONTENT_CLASSES.BOOK,
    };
  });
  return { total, languageFacets, results, suggested_query };
};

